import { buildPaginationTokens } from '../utils/paginationTokens'
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from './pagination'

export default function AppPagination({
  page = 1,
  totalPages = 1,
  onPageChange,
  onPrevious,
  onNext,
  canPrevious,
  canNext,
  className = '',
}) {
  const effectiveCanPrevious = canPrevious !== undefined ? canPrevious : page > 1
  const effectiveCanNext = canNext !== undefined ? canNext : page < totalPages

  const handlePrevious = (e) => {
    e?.preventDefault?.()
    if (!effectiveCanPrevious) return
    if (onPrevious) {
      onPrevious()
    } else if (onPageChange) {
      onPageChange(Math.max(1, page - 1))
    }
  }

  const handleNext = (e) => {
    e?.preventDefault?.()
    if (!effectiveCanNext) return
    if (onNext) {
      onNext()
    } else if (onPageChange) {
      onPageChange(Math.min(totalPages, page + 1))
    }
  }

  const tokens = buildPaginationTokens(page, totalPages)

  return (
    <Pagination className={className}>
      <PaginationContent className="w-full justify-end">
        <PaginationItem>
          <PaginationPrevious onClick={handlePrevious} disabled={!effectiveCanPrevious} />
        </PaginationItem>

        {tokens.map((token) => {
          if (String(token).startsWith('ellipsis')) {
            return (
              <PaginationItem key={String(token)}>
                <PaginationEllipsis />
              </PaginationItem>
            )
          }

          const pageNumber = Number(token)
          return (
            <PaginationItem key={pageNumber}>
              <PaginationLink
                isActive={page === pageNumber}
                onClick={() => onPageChange?.(pageNumber)}
              >
                {pageNumber}
              </PaginationLink>
            </PaginationItem>
          )
        })}

        <PaginationItem>
          <PaginationNext onClick={handleNext} disabled={!effectiveCanNext} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
